import _styled from "styled-components";
import ArrowLeft from '@crehana/icons/outline/ArrowLeft';
import ArrowRight from '@crehana/icons/outline/ArrowRight';
import BaseButton from "../../../Buttons/BaseButton";
import { primaryMain, secondaryLight } from "../../../styles/colors";
import transition from "../../../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowButton = function ArrowButton(_ref) {
  var direction = _ref.direction,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    dark = _ref.dark;
  var ArrowIcon = direction === 'left' ? ArrowLeft : ArrowRight;
  return /*#__PURE__*/_jsx(_StyledBaseButton, {
    className: "w-72 h-72 flex-shrink-0 ".concat(dark ? 'bg-base-dark' : 'bg-white'),
    onClick: onClick,
    disabled: disabled,
    $_css: transition('opacity'),
    children: /*#__PURE__*/_jsx(ArrowIcon, {
      size: 24,
      color: dark ? secondaryLight : primaryMain,
      className: disabled ? 'opacity-32' : ''
    })
  });
};
export default ArrowButton;
var _StyledBaseButton = /*#__PURE__*/_styled(BaseButton).withConfig({
  componentId: "sc-j3jmdb-0"
})(["\n        & > svg {\n          transition: ", ";\n        }\n      "], function (p) {
  return p.$_css;
});